import moment from "moment";

const isTimeProvided = (time: moment.Moment | null) => {
    return time && time.format("HH:mm") !== "00:00";
}

export const formatDate = (dates: [moment.Moment | Date | null, moment.Moment | Date | null], allDay?: boolean = false): null | string => {
    if (!dates[0] && !dates[1]) {
        return null;
    }

    const convertedDates: [moment.Moment | null, moment.Moment | null] = [null, null];

    if (dates[0]) {
        convertedDates[0] = moment(dates[0]);
        if (!convertedDates[0].isValid()) {
            return "";
        }
    }

    if (dates[1]) {
        convertedDates[1] = moment(dates[1]);
        if (!convertedDates[1].isValid()) {
            return "";
        }
    }

    if (convertedDates[0] && !convertedDates[1]) {
        return convertedDates[0].format("DD/MM/YY");
    }

    const isSameDay = convertedDates[0]?.isSame(convertedDates[1], 'day');
    const isSameMonth = convertedDates[0]?.isSame(convertedDates[1], 'month');
    const isSameYear = convertedDates[0]?.isSame(convertedDates[1], 'year');

    const startTimeProvided = isTimeProvided(convertedDates[0]);
    const endTimeProvided = isTimeProvided(convertedDates[1]);

    // Formatting rules
    const startDateFormat = startTimeProvided ? "DD.MM" : "DD.MM";
    const endDateFormat = endTimeProvided ? "DD.MM" : "DD.MM";
    const fullEndDateFormat = endTimeProvided ? "DD.MM.YY" : "DD.MM.YY";

    if (isSameDay) {
        if (!allDay) {
            return `${convertedDates[0].format("HH:mm")}-${convertedDates[1].format("HH:mm")} ${convertedDates[0].format("DD.MM.YY")}`;

        } else {
            return convertedDates[0].format("DD.MM.YY");
        }
    }

    if (isSameMonth) {
        return `${convertedDates[0].format(startDateFormat)}-${convertedDates[1].format(endDateFormat)} ${convertedDates[0].format("YY")}`;
    }

    if (isSameYear) {
        return `${convertedDates[0].format(startDateFormat)}-${convertedDates[1].format(fullEndDateFormat)}`;
    }

    // Different years
    return `${convertedDates[0].format(startDateFormat)}-${convertedDates[1].format(fullEndDateFormat)}`;
};
